import { GoogleAnalytics, HelpScout } from '../../../services'

export const loggedOut = () => {
  // helpscout
  HelpScout.logout()

  // google analytics
  GoogleAnalytics.identify()
}
